import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=logged out, obj=user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      // Returning from Google OAuth: let AuthCallback exchange the session_id first.
      if (window.location.hash?.includes("session_id=")) {
        setReady(true);
        return;
      }
      const token = localStorage.getItem("ns_token");
      if (!token) {
        setUser(false);
        setReady(true);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data.user);
      } catch {
        localStorage.removeItem("ns_token");
        setUser(false);
      }
      setReady(true);
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ns_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("ns_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("ns_token");
    localStorage.removeItem("ns_admin_token");
    setUser(false);
  };

  const impersonate = (token, impUser) => {
    const adminTok = localStorage.getItem("ns_token");
    if (adminTok) localStorage.setItem("ns_admin_token", adminTok);
    localStorage.setItem("ns_token", token);
    setUser(impUser);
  };

  const stopImpersonation = async () => {
    const adminTok = localStorage.getItem("ns_admin_token");
    if (!adminTok) return null;
    localStorage.setItem("ns_token", adminTok);
    localStorage.removeItem("ns_admin_token");
    const { data } = await api.get("/auth/me");
    setUser(data.user);
    return data.user;
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, setUser, impersonate, stopImpersonation }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
